import { render, staticRenderFns } from "./spbs.vue?vue&type=template&id=7320c09c&scoped=true"
import script from "./spbs.vue?vue&type=script&lang=js"
export * from "./spbs.vue?vue&type=script&lang=js"
import style0 from "./spbs.vue?vue&type=style&index=0&id=7320c09c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320c09c",
  null
  
)

export default component.exports